import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {AsyncTypeahead, Typeahead, Menu, MenuItem} from 'react-bootstrap-typeahead';

const RelatedItems = (props) => {
    const project_id = props.project_id
    const disabled = props.disabled
    const project_type = props.project_type || 'Project'
    let related_items = props.related_items || []
    const previous_version_related_items = props.previous_version_related_items || []
    
    const [ addRelatedItemIsLoading, setAddRelatedItemIsLoading ] = useState(false)
    const [ addRelatedItemSelected, setAddRelatedItemSelected ] = useState([])
    const [ addRelatedItemOptions, setAddRelatedItemOptions ] = useState([])
        
    const handleCopyPreviousVersionRelatedItems = () => {
        // Just check we're not double adding any
        let to_add = props.previous_version_related_items.filter(item => {
            return ! related_items.find(related => (item.type === related.type && item.id === related.id ))
        })
        related_items = related_items.concat(to_add)
        props.onChange(related_items)
    }
    
    const handleDeleteRelatedItem = (item) => {
        props.onChange(related_items.filter(function (i) {
            return i.id != item.id
        }))
    }

    let relatedItemsList = []
    if ( related_items ) {
        for (let item of related_items ) {
            let deleteItemButton = null
            if ( ! disabled ) {
                deleteItemButton = (
                    <button type="button" className="btn btn-xs btn-delete"
                            onClick={() => handleDeleteRelatedItem(item)}>Delete
                    </button>
                )
            }

            relatedItemsList.push(
                <li key={item.display_name} className="list-group-item">
                    <Link to={`/portfolio/${project_id}/${item.type}/${item.id}`}>{item.display_name}</Link>
                    &nbsp;
                    {deleteItemButton}
                </li>
            )
        }
    }

    let addRelatedItemForm = []
    // default to disabled field
    addRelatedItemForm.push(
        <input
            className="form-control"
            type="text"
            name="disabled-related-item-form"
            disabled={disabled}
        />
    )

    if ( ! disabled ) {
        addRelatedItemForm = []
        addRelatedItemForm.push(
            <AsyncTypeahead
                id="typeahead"
                key="typeahead"
                placeholder="Start typing to search..."
                isLoading={addRelatedItemIsLoading}
                filterBy={(option, props) => {
                        return true
                    }}
                minLength={2}
                useCache={false}
                renderMenu={(results, menuProps) => (
                        <Menu {...menuProps}>
                              {results.map(function(result, index) {
                                   if( result.type == 'header' ) {
                                       return (
                                           <li role="option" key={index}>
                                               <div className="dropdown-item">{result.display_name}</div>
                                           </li>
                                       )
                                   } else {
                                       return (
                                           <MenuItem option={result} position={index} key={index}>
                                                                                          {result.display_name}
                                           </MenuItem>
                                       )
                                   }
                               })}
                        </Menu>
                    )}
                onChange={(selected) => {
                        related_items.push(selected[0])
                        props.onChange(related_items)
                        setAddRelatedItemSelected([])
                    }}
                onSearch={query => {
                        setAddRelatedItemIsLoading(true)
                        fetch(`/v0/cadm_search?project_id=${project_id}&query=${query}`, { credentials: 'same-origin' })
                            .then(function(response) {
                                return response.json()
                            })
                            .then(function(json) {
                                json.results.forEach(function (element) {
                                    element.label = element.display_name
                                })

                                // Clear already related items
                                let options = json.results.filter(item => {
                                    return ! related_items.find(related => (item.type === related.type && item.id === related.id ))
                                })
                                // Clear current object as well
                                const object_type = props.object_type
                                const object_reference_without_version = props.object_reference_without_version
                                options = options.filter(item => {
                                    return ! ( item.type === object_type && item.reference_without_version === object_reference_without_version )
                                })
                                
                                setAddRelatedItemIsLoading(false)
                                setAddRelatedItemOptions(options)
                            })
                    }}
                options={addRelatedItemOptions}
                selected={addRelatedItemSelected}
            />
        )
    }

    let copy_previous_version_related_items = null
    if( previous_version_related_items.length > 0 ) {
        copy_previous_version_related_items = (
            <small className="form-info-text" data-tooltip-id="gnctooltip" data-tooltip-content="Add all related items from the previous version of this document. Related items in the previous version will not be changed.">
                <a onClick={() => handleCopyPreviousVersionRelatedItems() }>
                    Add all from previous version.
                </a>
            </small>
        )
    }
        
    return (
        <span>
            <div className="form-group">
                <label className="col-sm-2 control-label"></label>
                <div className="col-sm-8">
                    <label className="control-label">Related Items</label>
                    <br/>
                    <small className="form-info-text" >
                        Only Related Items within this {project_type} are listed here.
                    </small>
                    <ul className="list-group clear-list m-t" style={{marginBottom: '0px'}}>
                        {relatedItemsList}
                    </ul>
                </div>
            </div>

            <div className="form-group">
                <label className="col-sm-2 control-label">Add</label>
                <div className="col-sm-8">
                    {addRelatedItemForm}
                    {copy_previous_version_related_items}
                </div>
            </div>
        </span>
    )
}

export default RelatedItems
